export default __webpack_public_path__ + "static/pexels-anna-nekrashevich-6801872-af4e6e66651547d4cb69c8b54485fdb2.jpg";